<div class="container mx-auto mt-5 px-4">
  <!-- Sección previa al inicio de evaluación -->
  <div
    *ngIf="!temporizadorActivo"
    class="bg-gray-50 p-6 rounded-xl shadow-md border border-gray-200"
  >
    <div *ngIf="evaluacion" class="space-y-3">
      <h3 class="text-2xl font-bold text-gray-800">{{ evaluacion.nombre }}</h3>
      <div class="flex items-center text-gray-600">
        <svg
          class="w-5 h-5 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          ></path>
        </svg>
        <span><strong>Área:</strong> {{ evaluacion.area.nombre }}</span>
      </div>
      <div class="flex items-center text-gray-600">
        <svg
          class="w-5 h-5 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          ></path>
        </svg>
        <span
          ><strong>Fecha de Fin:</strong>
          {{ evaluacion.fecha_fin | date : "dd/MM/yyyy" }}</span
        >
      </div>
      <div class="flex items-center text-gray-600">
        <svg
          class="w-5 h-5 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <span
          ><strong>Duración:</strong> {{ evaluacion.duracion }} minutos</span
        >
      </div>
    </div>

    <!-- Sección de advertencias -->
    <div class="mt-6 bg-amber-50 border-l-4 border-amber-400 rounded-r-lg p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg
            class="h-5 w-5 text-amber-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-lg font-medium text-amber-800">
            Información importante
          </h3>
          <div class="mt-2 text-sm text-amber-700">
            <ul class="list-disc pl-5 space-y-1">
              <li>
                Este es un examen de opción múltiple con una sola respuesta
                correcta por pregunta
              </li>
              <li>
                Una vez iniciada la evaluación, solo podrá realizarse una vez
              </li>
              <li>No podrá pausar la evaluación ni refrescar la página</li>
              <li>Verifique su conexión a internet antes de iniciar</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="mt-6 flex justify-between">
      <button
        (click)="volver()"
        class="block bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
      >
        Volver
      </button>
      <button
        (click)="iniciarEvaluacion()"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-semibold rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        <svg
          class="-ml-1 mr-2 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        Iniciar Evaluación
      </button>
    </div>
  </div>

  <!-- Sección durante la evaluación -->
  <div
    *ngIf="temporizadorActivo"
    class="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6"
  >
    <!-- Visor de imágenes -->
    <div
      class="relative h-[90vh] border rounded-xl shadow-sm overflow-hidden bg-gray-100"
    >
      <img
        *ngIf="imagenes.length > 0"
        [src]="imagenes[imagenActualIndex].url_imagen"
        alt="Imagen {{ imagenActualIndex + 1 }} de {{ imagenes.length }}"
        class="w-full h-full object-contain transition-transform duration-300 ease-in-out"
      />

      <!-- Controles de navegación -->
      <div
        class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4"
      >
        <div class="flex justify-between items-center">
          <button
            [disabled]="imagenActualIndex === 0"
            (click)="anteriorImagen()"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-white/20 hover:bg-white/30 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <svg
              class="-ml-1 mr-2 h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
            Anterior
          </button>

          <span
            class="px-3 py-1 rounded-full text-sm font-medium text-white bg-black/50"
          >
            {{ imagenActualIndex + 1 }}/{{ imagenes.length }}
          </span>

          <button
            [disabled]="imagenActualIndex === imagenes.length - 1"
            (click)="siguienteImagen()"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-white/20 hover:bg-white/30 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Siguiente
            <svg
              class="-mr-1 ml-2 h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Sección de preguntas -->
    <div class="space-y-4">
      <!-- Barra de progreso y tiempo -->
      <div class="bg-blue-50 p-4 rounded-lg border border-blue-100">
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <svg
              class="h-5 w-5 text-blue-500 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <span class="text-sm font-medium text-blue-800">
              {{ preguntasRespondidas }}/{{ preguntas.length }} preguntas
              respondidas
            </span>
          </div>
          <div class="flex items-center">
            <svg
              class="h-5 w-5 text-blue-500 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <span class="text-lg font-semibold text-blue-800">
              {{ tiempoRestante | formatTime }}s
            </span>
          </div>
          <button
            (click)="finalizar()"
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <svg
              class="-ml-0.5 mr-2 h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
            Entregar
          </button>
        </div>
      </div>

      <!-- Alerta de preguntas sin responder -->
      <div
        *ngIf="preguntasSinResponder.length > 0"
        class="bg-amber-50 border-l-4 border-amber-400 rounded-r-lg p-4"
      >
        <div class="flex">
          <div class="flex-shrink-0">
            <svg
              class="h-5 w-5 text-amber-400"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-amber-800">¡Atención!</h3>
            <div class="mt-1 text-sm text-amber-700">
              <p>
                Faltan responder las preguntas:
                <span class="font-medium">
                  {{ preguntasSinResponder.join(", ") }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Contenedor de pregunta actual -->
      <div class="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold text-gray-800">
            Pregunta {{ currentQuestionIndex + 1 }} de {{ preguntas.length }}
          </h3>
        </div>

        <!-- Alternativas -->
        <div *ngIf="preguntas && preguntas.length > 0" class="space-y-3 mt-4">
          <div
            *ngFor="
              let alternativa of preguntas[currentQuestionIndex]?.alternativas;
              let i = index
            "
            (click)="seleccionarAlternativa(alternativa.id_alternativa, $event)"
            class="p-4 border rounded-lg cursor-pointer transition-all duration-200 hover:border-blue-300 hover:bg-blue-50"
            [class.border-blue-400]="
              respuestas[currentQuestionIndex] === alternativa.id_alternativa
            "
            [class.bg-blue-50]="
              respuestas[currentQuestionIndex] === alternativa.id_alternativa
            "
          >
            <label class="flex items-center space-x-3 cursor-pointer">
              <input
                type="radio"
                name="respuesta"
                [(ngModel)]="respuestas[currentQuestionIndex]"
                [value]="alternativa.id_alternativa"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
              />
              <span class="font-semibold mr-2"> {{ getLetter(i) }}) </span>
            </label>

          </div>

        </div>

        <!-- Navegación entre preguntas -->
        <div class="mt-6 flex justify-between">
          <button
            [disabled]="currentQuestionIndex === 0"
            (click)="anteriorPregunta()"
            class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg
              class="-ml-1 mr-2 h-5 w-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
            Anterior
          </button>
          <button
            [disabled]="currentQuestionIndex === preguntas.length - 1"
            (click)="siguientePregunta()"
            class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Siguiente
            <svg
              class="-mr-1 ml-2 h-5 w-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Navegación rápida por preguntas -->
      <div class="mt-4">
        <h4 class="text-sm font-medium text-gray-700 mb-2">
          Navegación rápida
        </h4>
        <div class="grid grid-cols-5 sm:grid-cols-8 md:grid-cols-10 gap-2">
          <button
            *ngFor="
              let i of [].constructor(preguntas.length);
              let index = index
            "
            (click)="currentQuestionIndex = index"
            class="w-full h-10 flex items-center justify-center rounded-md border text-sm font-medium"
            [class.border-blue-500]="currentQuestionIndex === index"
            [class.bg-blue-50]="currentQuestionIndex === index"
            [class.text-blue-600]="currentQuestionIndex === index"
            [class.border-gray-300]="currentQuestionIndex !== index"
            [class.bg-white]="
              !respuestas[index] && currentQuestionIndex !== index
            "
            [class.bg-green-50]="
              respuestas[index] && currentQuestionIndex !== index
            "
            [class.border-green-300]="
              respuestas[index] && currentQuestionIndex !== index
            "
            [class.text-green-600]="
              respuestas[index] && currentQuestionIndex !== index
            "
          >
            {{ index + 1 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
